import testimonialSchema from '../schemas/testimonialSchema';
import { jsonToFormData } from '../../helpers/HelperFunctions';

const LOADTESTIMONIAL = 'twineApp/testimonials/LOADTESTIMONIAL';
const LOADTESTIMONIAL_SUCCESS = 'twineApp/testimonials/LOADTESTIMONIAL_SUCCESS';
const LOADTESTIMONIAL_FAIL = 'twineApp/testimonials/LOADTESTIMONIAL_FAIL';
const ADD_TESTIMONIAL = 'twineApp/testimonials/ADD_TESTIMONIAL';
const ADD_TESTIMONIAL_SUCCESS = 'twineApp/testimonials/ADD_TESTIMONIAL_SUCCESS';
const ADD_TESTIMONIAL_FAIL = 'twineApp/testimonials/ADD_TESTIMONIAL_FAIL';
const LOAD_REQUESTS = 'twineApp/testimonials/LOAD_REQUESTS';
const LOAD_REQUESTS_SUCCESS = 'twineApp/testimonials/LOAD_REQUESTS_SUCCESS';
const LOAD_REQUESTS_FAIL = 'twineApp/testimonials/LOAD_REQUESTS_FAIL';
const UPDATE_TESTIMONIAL = 'twineApp/testimonials/UPDATE_TESTIMONIAL';
const UPDATE_TESTIMONIAL_SUCCESS =
  'twineApp/testimonials/UPDATE_TESTIMONIAL_SUCCESS';
const UPDATE_TESTIMONIAL_FAIL = 'twineApp/testimonials/UPDATE_TESTIMONIAL_FAIL';

const initialState = {
  testimonial: null,
  loadingTestimonial: false,
  loadedTestimonial: false,
  addingTestimonial: false,
  addSuccessful: false,
  updatingTestimonial: false,
  updateSuccessful: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOADTESTIMONIAL:
      return {
        ...state,
        loadingTestimonial: true,
      };

    case LOADTESTIMONIAL_SUCCESS:
      return {
        ...state,
        loadingTestimonial: false,
        loadedTestimonial: true,
        testimonial: action.result,
      };

    case LOADTESTIMONIAL_FAIL:
      return {
        ...state,
        loadingTestimonial: false,
      };

    case ADD_TESTIMONIAL:
      return {
        ...state,
        addingTestimonial: true,
      };

    case ADD_TESTIMONIAL_SUCCESS:
      return {
        ...state,
        addingTestimonial: false,
        addSuccessful: true,
      };

    case ADD_TESTIMONIAL_FAIL:
      return {
        ...state,
        addingTestimonial: false,
        addSuccessful: false,
      };

    case UPDATE_TESTIMONIAL:
      return {
        ...state,
        updatingTestimonial: true,
      };

    case UPDATE_TESTIMONIAL_SUCCESS:
      return {
        ...state,
        updatingTestimonial: false,
        updateSuccessful: true,
      };

    case UPDATE_TESTIMONIAL_FAIL:
      return {
        ...state,
        updatingTestimonial: false,
        updateSuccessful: false,
      };

    default:
      return state;
  }
}

export function loadTestimonial(id, authCode = null) {
  return {
    types: [LOADTESTIMONIAL, LOADTESTIMONIAL_SUCCESS, LOADTESTIMONIAL_FAIL],
    promise: (client) =>
      client.get(
        '/testimonials/' +
          id +
          '?include=user' +
          (authCode.length > 0 ? '&auth_code=' + authCode : '')
      ),
    schema: testimonialSchema,
  };
}

export function addTestimonial(name, companyName, projectName, email, phone) {
  const fields = {
    name: name,
    company_name: companyName,
    project_name: projectName,
    email: email,
    phone: phone,
  };
  // The API turns '' into null, which fails its string rules, so optional
  // fields left blank are not sent at all.
  const data = Object.keys(fields).reduce(
    (result, key) =>
      fields[key] && String(fields[key]).trim()
        ? { ...result, [key]: String(fields[key]).trim() }
        : result,
    {}
  );

  return {
    types: [ADD_TESTIMONIAL, ADD_TESTIMONIAL_SUCCESS, ADD_TESTIMONIAL_FAIL],
    promise: (client) => client.post('/testimonials', { data }),
  };
}

/**
 * Requests the user has sent that nobody has written yet. Only the owner's
 * testimonials modal needs these, so the caller keeps the result. Every page
 * is fetched so none are left out.
 */
export function loadTestimonialRequests(username) {
  return {
    types: [LOAD_REQUESTS, LOAD_REQUESTS_SUCCESS, LOAD_REQUESTS_FAIL],
    promise: async (client) => {
      let testimonials = [];
      let page = 1;
      let totalPages = 1;
      do {
        const result = await client.get(
          `/users/${username}/testimonials?completed=0&limit=50&page=${page}`
        );
        testimonials = testimonials.concat(result?.testimonials || []);
        totalPages = result?.meta?.pagination?.total_pages || 1;
        page += 1;
      } while (page <= totalPages);
      return { testimonials };
    },
  };
}

export function updateTestimonial(id, fields, authCode) {
  return {
    types: [
      UPDATE_TESTIMONIAL,
      UPDATE_TESTIMONIAL_SUCCESS,
      UPDATE_TESTIMONIAL_FAIL,
    ],
    promise: (client) =>
      client.post('/testimonials/' + id + '?auth_code=' + authCode, {
        data: jsonToFormData({ ...fields, _method: 'PATCH' }),
      }),
  };
}
